import { connect } from 'react-redux';
import { CaseCancellation, mapDispatchToCaseCancellationProps, mapStateToCaseCancellationProps } from '@codametrix/shared-views';
export const CaseCancellationComponent = connect(mapStateToCaseCancellationProps, mapDispatchToCaseCancellationProps)(CaseCancellation);
